import axios from './axios'
export default {
  alertTipsMycustom (object) {
    let DOM = document.createElement('div')
    if (object.type === 'success') {
      DOM.className = 'allTips mycustomsuccess'
    } else {
      DOM.className = 'allTips error'
    }
    //let html = '<img src="https://biuat.takeda.com.cn/manual/fasongok.png" height="100px" width="100px"/>'
    let html = `<span style="font-size: 14px">${object.content}</span>`
    DOM.innerHTML = html
    document.body.appendChild(DOM)
    DOM.style.top = `calc(50% - ${DOM.clientHeight/2}px)`
    DOM.style.right = `calc(50% - ${DOM.clientWidth/2}px)`
    setTimeout(() => {
      DOM.style.right = `calc(50% - ${DOM.clientWidth/2}px)`
      setTimeout(() => {
        DOM.style.top = '-10%'
        setTimeout(() => {
          document.body.removeChild(DOM)
        }, 500)
      }, object.stayTime * 1000)
    }, 10)
  },
  alertTips (object) {
    let DOM = document.createElement('div')
    if (object.type === 'success') {
      DOM.className = 'allTips success'
    } else {
      DOM.className = 'allTips error'
    }
    // let html = `<span>${object.title}</span>: <span>${object.content}</span>`
    let html = `<span style="font-size: 16px">${object.content}</span>`
    DOM.innerHTML = html
    document.body.appendChild(DOM)
    // setTimeout(() => {
    //   DOM.style.top = '40px'
    // }, 10)
    // DOM.style.right = '45%'
    let tips = document.querySelectorAll('.allTips')
    if (tips.length === 1) {
      setTimeout(() => {
        DOM.style.top = '40px'
      }, 10)
      DOM.style.right = `calc(50% - ${DOM.clientWidth/2}px)`
    } else {
      setTimeout(() => {
        DOM.style.top = parseInt(tips[tips.length - 2].style.top.replace('px', ''), 0) + (tips[tips.length - 2].clientHeight + 12) + 'px'
      }, 10)
      DOM.style.right = `calc(50% - ${DOM.clientWidth/2}px)`
    }
    setTimeout(() => {
      DOM.style.right = `calc(50% - ${DOM.clientWidth/2}px)`
      setTimeout(() => {
        DOM.style.top = '-10%'
        setTimeout(() => {
          document.body.removeChild(DOM)
        }, 500)
      }, object.stayTime * 1000)
    }, 10)
  },
  returnQuery (url, object) {
    if (object) {
      let html = ''
      for (let i in object) {
        if (i === 'org_Acronym') {
          object[i] = object[i].replace(/&/g, '%26')
        }
        html += '&' + i + '=' + object[i]
      }
      html = html.substr(1, html.length - 1)
      return url + '?' + html
    }
  },
  returnQuery2 (url, object) {
    if (object) {
      let html = ''
      for (let i in object) {
        if (i === 'org_Acronym') {
          object[i] = object[i].replace(/&/g, '%26')
        }
        if (Object.prototype.toString.apply(object[i]) == '[object Array]' || Object.prototype.toString.apply(object[i]) == '[object Object]') {
          html += '&' + i + '=' + encodeURIComponent(JSON.stringify(object[i]))
        } else {
          html += '&' + i + '=' + encodeURIComponent(object[i])
        }
      }
      html = html.substr(1, html.length - 1)
      if (url.indexOf('?') >= 0) {
        return url + '&' + html
      } else {
        return url + '?' + html
      }
    }
  },
  showTips (value, time) {
    let dom = document.createElement('div')
    dom.id = 'doubleConfirm2'
    dom.classList.add('myRemind')
    dom.innerHTML = value
    document.body.appendChild(dom)
    setTimeout(p => {
      dom.style.opacity = 1
      setTimeout(p => {
        dom.style.opacity = 0
        setTimeout(p => {
          dom.style.opacity = 0
          document.body.removeChild(dom)
        }, 300)
      }, time || 2000)
    }, 10)
  },
  uploadFileWX (file) {
    let postFile = new FormData()
    postFile.append('file', file)
    var p = new Promise((resolve, reject) => {
      axios.post('api/WorkWechatMedia/upload', postFile).then(msg => {
        resolve(msg.result)
      })
    })
    return p
  },
  uploadUser (file) {
    let postFile = new FormData()
    postFile.append('file', file)
    var p = new Promise((resolve, reject) => {
      axios.postForUser('/api/employee/ImportEmployee', postFile).then(msg => {
        resolve(msg)
      })
    })
    return p
  },
  uploadUser2 (file) {
    let postFile = new FormData()
    postFile.append('file', file)
    var p = new Promise((resolve, reject) => {
      axios.postForUser('/api/employee/ImportEmployee2', postFile).then(msg => {
        resolve(msg)
      })
    })
    return p
  },
  // uploadFile (file) {
  //   let postFile = new FormData()
  //   postFile.append('file', file)
  //   var p = new Promise((resolve, reject) => {
  //     axios.post('api/Article/addfile', postFile).then(msg => {
  //       resolve(msg)
  //     })
  //   })
  //   return p
  // },
  uploadFile (file, url = '/api/Article/addThumb', fileName = 'file') {
    let postFile = new FormData()
    postFile.append(fileName, file)
    var p = new Promise((resolve, reject) => {
      axios.post(url, postFile).then(msg => {
        resolve(msg)
      })
    })
    return p
  },
  uploadFile2 (file, url = '/api/RotationChart/AddTagFile', fileName = 'file') {
    let postFile = new FormData()
    postFile.append(fileName, file)
    var p = new Promise((resolve, reject) => {
      axios.post(url, postFile).then(msg => {
        resolve(msg)
      })
    })
    return p
  },
  uploadFile3 (file, url = '/api/RotationChart/AddArticleTagFile', fileName = 'file') {
    let postFile = new FormData()
    postFile.append(fileName, file)
    var p = new Promise((resolve, reject) => {
      axios.post(url, postFile).then(msg => {
        resolve(msg)
      })
    })
    return p
  },
  mobileDoubleComfirm (object) {
    let dom = document.createElement('div')
    dom.id = 'doubleConfirm'
    dom.classList.add('showAllmodel')
    let buttomHtmlConform = ''
    let buttomHtmlCancel = ''
    if (object.lang === 'EN') {
      buttomHtmlConform += `<abbr>Confirm</abbr>`
      buttomHtmlCancel += `<abbr>Cancel</abbr>`
    } else {
      buttomHtmlConform += `<abbr>确定</abbr>`
      buttomHtmlCancel += `<abbr>取消</abbr>`
    }
    let footHtml = ''
    if (object.buttonType === '2') {
      footHtml += `<button id="confirmButtom" class="redButtonTwo">${buttomHtmlConform}</button>
          <button id="cancelButtom" class="cancelButtonTwo magleft_2">${buttomHtmlCancel}</button>`
    } else if (object.buttonType === '0') {

    } else {
      footHtml += `<button id="confirmButtom" class="redButtonTwo">${buttomHtmlConform}</button>`
    }
    let imgUrl = ''
    // if (object.type === 'error') {
    //   imgUrl += '<img style="margin: 10px 0" src="' + errorImg + '"  width="30%"/>'
    // } else if (object.type === 'success') {
    //   imgUrl += '<img style="margin: 10px 0" src="' + successImg + '"  width="30%"/>'
    // } else {
    //   imgUrl += '<img style="margin: 10px 0" src="' + warning + '"  width="30%"/>'
    // }
    let html = `
      <div class="alertcover"></div>
      <div class="allalertModel">
        <div class="alertTitle">${object.title}</div>
        <div class="alertcontent">
          ${imgUrl}
          <div>${object.content}</div>
        </div>
        <div class="alertfoot">
            ${footHtml}
        </div>
      </div>`
    dom.innerHTML = html
    document.body.appendChild(dom)
    let confirmButtom1 = document.getElementById('confirmButtom')
    if (confirmButtom1) {
      confirmButtom1.onclick = function (e) {
        if (object.successFun) {
          object.successFun(e)
        }
        document.body.removeChild(document.getElementById('doubleConfirm'))
      }
    }
    let cancelButtom1 = document.getElementById('cancelButtom')
    if (cancelButtom1) {
      cancelButtom1.onclick = function (e) {
        if (object.errorFun) {
          object.errorFun(e)
        }
        document.body.removeChild(document.getElementById('doubleConfirm'))
      }
    }
  },
  doubleComfirm (object) {
    if (document.getElementById('doubleConfirm') === null) {
      let dom = document.createElement('div')
      dom.id = 'doubleConfirm'
      let html = `<div class="newTips">
      <div class="cover"  style="opacity: 1"></div>
      <div id="newTipsBody2" class="newTipsBody">
        <ul>
          <li class="d_f" style="justify-content: space-between;align-items: baseline"><span></span><span class="font20">提示</span><i id="cancelButtom2" class="icon iconfont iconguanbi1" style="font-size: 20px"></i></li>
          <li class="t_c font24"><i class="icon iconfont icongantan m_r_10 colorCH" style="font-size: 25px;"></i><span style="font-size: 16px;" class="colorZh">${object.content}</span></li>
          <li class="t_c" style="margin-bottom: 3%">
            <button id="confirmButtom1" class="redButtonTwo m_r_10 m_l_10" >确定</button>
            <button id="cancelButtom1" class="cancelButtonTwo m_l_10 m_r_10" >取消</button>
          </li>
        </ul>
      </div>
    </div>`
      dom.innerHTML = html
      document.body.appendChild(dom)
      setTimeout(function () {
        document.getElementById('newTipsBody2').style.opacity = '1'
        document.getElementById('newTipsBody2').style.top = '-30px'
      }, 10)
      let confirmButtom1 = document.getElementById('confirmButtom1')
      if (confirmButtom1) {
        confirmButtom1.onclick = function (e) {
          object.successFun(e)
          document.getElementById('newTipsBody2').style.opacity = '0'
          document.getElementById('newTipsBody2').style.top = '-100px'
          setTimeout(function () {
            document.body.removeChild(document.getElementById('doubleConfirm'))
          }, 300)
        }
      }
      let cancelButtom1 = document.getElementById('cancelButtom1')
      if (cancelButtom1) {
        cancelButtom1.onclick = function (e) {
          object.errorFun(e)
          document.getElementById('newTipsBody2').style.opacity = '0'
          document.getElementById('newTipsBody2').style.top = '-100px'
          setTimeout(function () {
            document.body.removeChild(document.getElementById('doubleConfirm'))
          }, 300)
        }
      }
      let cancelButtom2 = document.getElementById('cancelButtom2')
      if (cancelButtom2) {
        cancelButtom2.onclick = function (e) {
          object.errorFun(e)
          document.getElementById('newTipsBody2').style.opacity = '0'
          document.getElementById('newTipsBody2').style.top = '-100px'
          setTimeout(function () {
            document.body.removeChild(document.getElementById('doubleConfirm'))
          }, 300)
        }
      }
    }
  },
  doubleComfirmTwo (object) {
    if (document.getElementById('doubleConfirm') === null) {
      let dom = document.createElement('div')
      dom.id = 'doubleConfirm'
      let html = `<div class="newTips">
      <div class="cover"  style="opacity: 1"></div>
      <div id="newTipsBody2" class="newTipsBody">
        <ul>
          <li class="d_f" style="justify-content: center;align-items: baseline"><span></span><span class="font20">提示</span></li>
          <li class="t_c font24"><i class="icon iconfont icongantan m_r_10 colorCH" style="font-size: 25px;"></i><span style="font-size: 16px;" class="colorZh">${object.content}</span></li>
          <li class="t_c" style="margin-bottom: 3%">
            <button id="confirmButtom1" class="redButtonTwo m_r_10 m_l_10" >是:AI重新打标签</button>
            <button id="cancelButtom1" class="cancelButtonTwo m_l_10 m_r_10" >否:展示上次选择标签</button>
          </li>
        </ul>
      </div>
    </div>`
      dom.innerHTML = html
      document.body.appendChild(dom)
      setTimeout(function () {
        document.getElementById('newTipsBody2').style.opacity = '1'
        document.getElementById('newTipsBody2').style.top = '-30px'
      }, 10)
      let confirmButtom1 = document.getElementById('confirmButtom1')
      if (confirmButtom1) {
        confirmButtom1.onclick = function (e) {
          object.successFun(e)
          document.getElementById('newTipsBody2').style.opacity = '0'
          document.getElementById('newTipsBody2').style.top = '-100px'
          setTimeout(function () {
            document.body.removeChild(document.getElementById('doubleConfirm'))
          }, 300)
        }
      }
      let cancelButtom1 = document.getElementById('cancelButtom1')
      if (cancelButtom1) {
        cancelButtom1.onclick = function (e) {
          object.errorFun(e)
          document.getElementById('newTipsBody2').style.opacity = '0'
          document.getElementById('newTipsBody2').style.top = '-100px'
          setTimeout(function () {
            document.body.removeChild(document.getElementById('doubleConfirm'))
          }, 300)
        }
      }
      let cancelButtom2 = document.getElementById('cancelButtom2')
      if (cancelButtom2) {
        cancelButtom2.onclick = function (e) {
          object.errorFun(e)
          document.getElementById('newTipsBody2').style.opacity = '0'
          document.getElementById('newTipsBody2').style.top = '-100px'
          setTimeout(function () {
            document.body.removeChild(document.getElementById('doubleConfirm'))
          }, 300)
        }
      }
    }
  },
  // 复制
  copyComfirm (object) {
    if (document.getElementById('doubleConfirm') === null) {
      let dom = document.createElement('div')
      dom.id = 'doubleConfirm'
      let html = `<div class="newTips">
      <div class="cover"  style="opacity: 1"></div>
      <div id="newTipsBody2" class="newTipsBody">
        <ul>
          <li class="d_f" style="justify-content: space-between;align-items: baseline"><span></span><span class="font20">提示</span><i id="cancelButtom2" class="icon iconfont iconguanbi1" style="font-size: 20px"></i></li>
          <li class="t_c font24"><i class="icon iconfont icongantan m_r_10 colorCH" style="font-size: 25px;"></i><span style="font-size: 16px;" class="colorZh">${object.content}</span></li>
          <li class="t_c" style="margin-bottom: 3%">
            <button id="confirmButtom1" class="redButtonTwo m_r_10 m_l_10" >复制</button>
          </li>
        </ul>
      </div>
    </div>`
      dom.innerHTML = html
      document.body.appendChild(dom)
      setTimeout(function () {
        document.getElementById('newTipsBody2').style.opacity = '1'
        document.getElementById('newTipsBody2').style.top = '-30px'
      }, 10)
      let confirmButtom1 = document.getElementById('confirmButtom1')
      if (confirmButtom1) {
        confirmButtom1.onclick = function (e) {
          object.successFun(e)
          document.getElementById('newTipsBody2').style.opacity = '0'
          document.getElementById('newTipsBody2').style.top = '-100px'
          setTimeout(function () {
            document.body.removeChild(document.getElementById('doubleConfirm'))
          }, 300)
        }
      }
      let cancelButtom1 = document.getElementById('cancelButtom1')
      if (cancelButtom1) {
        cancelButtom1.onclick = function (e) {
          object.errorFun(e)
          document.getElementById('newTipsBody2').style.opacity = '0'
          document.getElementById('newTipsBody2').style.top = '-100px'
          setTimeout(function () {
            document.body.removeChild(document.getElementById('doubleConfirm'))
          }, 300)
        }
      }
      let cancelButtom2 = document.getElementById('cancelButtom2')
      if (cancelButtom2) {
        cancelButtom2.onclick = function (e) {
          object.errorFun(e)
          document.getElementById('newTipsBody2').style.opacity = '0'
          document.getElementById('newTipsBody2').style.top = '-100px'
          setTimeout(function () {
            document.body.removeChild(document.getElementById('doubleConfirm'))
          }, 300)
        }
      }
    }
  },
  commonPageSize: 10,
  getGender (num) {
    if (num === -1) {
      return '未知'
    }
    if (num === 0) {
      return '男'
    }
    if (num === 1) {
      return '女'
    }
    return '-'
  },
  returnNewDate (date) {
    if (date === null || date === '' || date === undefined) {
      return ''
    } else {
      return date.split('.')[0].replace('T', ' ')
    }
  },
  returnDate (date, type) {
    if (date === null || date === '' || date === undefined) {
      return ''
    } else {
      let newDate 
      if (typeof(date) === 'string'){
        newDate = new Date(date.replace(/-/g, '/'))
      } else {
        newDate = new Date(date)
      }
      let year = newDate.getFullYear()
      let month = newDate.getMonth() + 1
      let Todate = newDate.getDate()
      let hour = newDate.getHours()
      let min = newDate.getMinutes()
      let sec = newDate.getSeconds()
      let zhYear = window.localStorage.getItem('lang') === '0' ? '/' : '年'
      let zhMouth = window.localStorage.getItem('lang') === '0' ? '/' : '月'
      let zhDate = window.localStorage.getItem('lang') === '0' ? ' ' : '日'
      month = month < 10 ? '0' + month : month
      Todate = Todate < 10 ? '0' + Todate : Todate
      hour = hour < 10 ? '0' + hour : hour
      min = min < 10 ? '0' + min : min
      sec = sec < 10 ? '0' + sec : sec
      if (type === 'YYMMDDHHMMSS') {
        return year + '/' + month + '/' + Todate + ' ' + hour + ':' + min + ':' + sec
      } else if (type === 'YYMMDD') {
        return year + '/' + month + '/' + Todate
      }else if (type === 'YYMM') {
        return year + '/' + month
      }else if (type === 'YYMMDD1') {
        return year + '-' + month + '-' + Todate
      } else if (type === 'YYMMDDHHMM') {
        return year + '/' + month + '/' + Todate + ' ' + hour + ':' + min
      } else if (type === 'YYMMDDZH') {
        return year + zhYear + month + zhMouth + Todate + zhDate
      } else if (type === 'HHMMSS') {
        return hour + ':' + min
      }
    }
  },
  returnNowDate(type){
    let newDate = new Date()
    let year = newDate.getFullYear()
    let month = newDate.getMonth() + 1
    let Todate = newDate.getDate()
    let hour = newDate.getHours()
    let min = newDate.getMinutes()
    let sec = newDate.getSeconds()
    let zhYear = window.localStorage.getItem('lang') === '0' ? '/' : '年'
    let zhMouth = window.localStorage.getItem('lang') === '0' ? '/' : '月'
    let zhDate = window.localStorage.getItem('lang') === '0' ? ' ' : '日'
    month = month < 10 ? '0' + month : month
    Todate = Todate < 10 ? '0' + Todate : Todate
    hour = hour < 10 ? '0' + hour : hour
    min = min < 10 ? '0' + min : min
    sec = sec < 10 ? '0' + sec : sec
    if (type === 'YYMMDDHHMMSS') {
      return year + '/' + month + '/' + Todate + ' ' + hour + ':' + min + ':' + sec
    } else if (type === 'YYMMDD') {
      return year + '/' + month + '/' + Todate
    } else if (type === 'YYMMDDHHMM') {
      return year + '/' + month + '/' + Todate + ' ' + hour + ':' + min
    } else if (type === 'YYMMDDZH') {
      return year + zhYear + month + zhMouth + Todate + zhDate
    } else if (type === 'HHMMSS') {
      return hour + ':' + min
    }



  },
  checkIfEmpty (data, list, value) {
    let content = '请检查必填项！'
    if (value) {
      content = value
    }
    for (let i in data) {
      if (list.indexOf(i) >= 0 && data[i] === '') {
        this.alertTips({
          type: 'error',
          title: '提示',
          content: content,
          stayTime: 5
        })
        return true
      }
    }
    return false
  },
  getDay (day) {
    var today = new Date()
    var targetdaymilliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day
    today.setTime(targetdaymilliseconds)
    var tYear = today.getFullYear()
    var tMonth = today.getMonth()
    var tDate = today.getDate()
    tMonth = this.doHandleMonth(tMonth + 1)
    tDate = this.doHandleMonth(tDate)
    return tYear + '-' + tMonth + '-' + tDate
  },
  doHandleMonth (month) {
    var m = month
    if (month.toString().length === 1) {
      m = '0' + month
    }
    return m
  },
  // 数组去重
  distinct (list1, list2) {
    for (let i = 0; i < list1.length; i++) {
      for (let j = 0; j < list2.length; j++) {
        if (list1[i].id === list2[j].id) {
          list2.splice(j, 1)
          j--
        }
      }
    }
    let newList = list1.concat(list2)
    return newList
  },
  // 数组去重
  conbinedistinct (list1, list2, name) {
    for (let i = 0; i < list1.length; i++) {
      for (let j = 0; j < list2.length; j++) {
        if (list1[i][name] === list2[j][name]) {
          list2.splice(j, 1)
          j--
        }
      }
    }
    let newList = list1.concat(list2)
    return newList
  },
  getHrefName (name) {
    // let url = window.location.hash
  },
  todayDate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
  firstDate: new Date(new Date().setDate(1)).getFullYear() + '-' + (new Date(new Date().setDate(1)).getMonth() + 1) + '-' + new Date(new Date().setDate(1)).getDate(),
  // 关闭当前窗口
  closeWindow () {
    try {
      console.log('关闭')
      console.log(WeixinJSBridge, 'WeixinJSBridge')
      // 这个可以关闭安卓系统的手机
      document.addEventListener('WeixinJSBridgeReady',
      function () {
        WeixinJSBridge.call('closeWindow')
      }, false)
      // 这个可以关闭ios系统的手机
      WeixinJSBridge.call('closeWindow')
      // 其他
      window.opener = null
      window.open('', '_self')
      window.close()
      window.open('about:blank', '_self').close()
    } catch (err) {
      console.log(err, 'err')
    }
  },

  returnToObtainDom (domType, toId) {
    let myH = domType
    let dom = document.createElement('section')
    dom.innerHTML = myH
    dom.querySelector('#' + toId).remove()
    return dom.innerHTML
  },
  getUrlParam(name, url) {
    let qs = arguments[1] || window.location.href,
        reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"),
        r = qs.substr(qs.indexOf("?") + 1).match(reg);
    if(r !== null){
      let i = decodeURI(r[2]).indexOf('#');
      if(i !== -1) {
        return decodeURI(r[2]).substring(0,i);
      }else{
        return decodeURI(r[2]);
      };
    }else{
      return '';
    };
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js